<template>
  <div style="background-color: #f5f5f5">
    <form @submit.prevent="submit" class="flight-school-connect-form">
      <div class="logoDiv">
        <img class="logo" alt="" src="/static/img/SignInPageHiloLogo.png" />
      </div>
      <Steps
        v-if="userTypeId"
        :step="step"
        :count="(componentList || []).length"
      />

      <component
        :is="current?.component || 'CreateAccount'"
        :title="current?.title"
        :user="user"
        :userTypeId="userTypeId"
        :userId="userId"
        :lenderId="lenderId"
        @onNext="next"
        @onPrev="prev"
        @onRoleChange="handleRoleChange"
        @setUserInfoAndNext="setUserInfoAndNext"
        @setLenderId="setLenderId"
        component=""
      />
    </form>
  </div>
</template>
<script>
import Steps from "./Steps.vue";

import CreateAccount from "./Steps/CreateAccount.vue";
import StudentAboutYou from "./Steps/StudentAboutYou.vue";
import InstructorAboutYou from "./Steps/InstructorAboutYou.vue";
import DispatchAboutYou from "./Steps/DispatchAboutYou.vue";
import AdminAboutYou from "./Steps/AdminAboutYou.vue";
import OwnerAboutYou from "./Steps/OwnerAboutYou.vue";
import LenderAboutYou from "./Steps/LenderAboutYou.vue";
import MaintenanceAboutYou from "./Steps/MaintenanceAboutYou.vue";
import DpeAboutYou from "./Steps/DpeAboutYou.vue";
import AmeAboutYou from "./Steps/AmeAboutYou.vue";
import AirlineAboutYou from "./Steps/AirlineAboutYou.vue";
import StudentFinanceOptions from "./Steps/StudentFinanceOptions.vue";
import StudentFinanceOffer from "./Steps/StudentFinanceOffer.vue";

import FlightSchoolConnect from "./Steps/FlightSchoolConnect.vue";
import Documents from "./Steps/Documents.vue";
import FinancingOptions from "./Steps/FinancingOptions.vue";
import LenderConnections from "./Steps/LenderConnections.vue";

import { SIGN_UP_PAGES } from "@/util/constants.js";
import StudentCriteria from "./Steps/StudentCriteria.vue";
import FlightSchoolCriteria from "./Steps/FlightSchoolCriteria.vue";
import HiloIntegrations from "./Steps/HiloIntegrations.vue";

export default {
  components: {
    Steps,
    CreateAccount,

    StudentAboutYou,
    InstructorAboutYou,
    DispatchAboutYou,
    AdminAboutYou,
    OwnerAboutYou,
    LenderAboutYou,
    MaintenanceAboutYou,
    DpeAboutYou,
    AmeAboutYou,
    AirlineAboutYou,
    StudentFinanceOptions,
    StudentFinanceOffer,

    StudentCriteria,
    FlightSchoolCriteria,
    HiloIntegrations,

    FlightSchoolConnect,
    Documents,
    FinancingOptions,
    LenderConnections,
  },
  data() {
    return {
      form: {},
      step: 1,
      user: {},
      userTypeId: null,
      userId: null,
      lenderId: null,
      nextPage: null,
      componentList: [],
      SIGN_UP_PAGES,
    };
  },
  computed: {
    current() {
      if (!this.userTypeId || !this.componentList.length) {
        return {
          component: "CreateAccount",
          title: "Create Account",
        };
      }

      return this.componentList[this.step - 1];
    },
  },
  methods: {
    setUserInfoAndNext(user, nextPage = null) {
      this.user = user;
      this.userId = user.id;
      this.userTypeId = user.userTypeId;
      if (user.lenderId) this.lenderId = user.lenderId;

      const defaultComponent = {
        component: "CreateAccount",
        title: "Create Account",
      };

      const pageKey = Object.keys(SIGN_UP_PAGES).find(
        (key) => parseInt(key) === user.userTypeId,
      );

      this.componentList = [...(SIGN_UP_PAGES[pageKey] || [])];

      const alreadyHasCreateAccount = this.componentList.some(
        (comp) => comp.component === defaultComponent.component,
      );

      if (!alreadyHasCreateAccount) {
        this.componentList.unshift(defaultComponent);
      }

      if (nextPage) {
        const nextIndex = this.componentList.findIndex(
          (comp) => comp.component === nextPage,
        );
        this.step = nextIndex >= 0 ? nextIndex + 1 : 2;
      } else {
        this.step = 2;
      }

      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    setLenderId(lenderId) {
      this.lenderId = lenderId;
    },
    next(payload = {}) {
      const maxLength = this.componentList.length;

      if (this.step < maxLength) {
        if (Object.entries(payload).length) {
          this.nextPage = null;
        }
        this.step++;
        Object.keys(payload).forEach((key) => {
          this.form[key] = payload[key];
        });
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    prev() {
      this.step--;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleRoleChange(id) {
      this.userTypeId = parseInt(id);
    },
    submit() {
      alert("Submitted");
    },
  },
};
</script>

<style>
.flight-school-connect-form {
  display: flex;
  font-family: Helvetica, Arial, sans-serif;
  flex-direction: column;
  max-width: 800px;
  gap: 1rem;
  margin: 0 auto;
  padding: 3rem 7rem;
  background-color: var(--color-background);
  z-index: 999;
  min-height: 100vh;
}
.flight-school-connect-form h2 {
  font-weight: bold;
  font-size: 2.3rem;
  color: #404040;
}
.logoDiv {
  display: flex;
  padding: 0;
  margin-top: -50px;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 100%;
}
.logo {
  width: 192.8px;
  position: relative;
  height: 51.7px;
  overflow: hidden;
  flex-shrink: 0;
}
</style>
